import * as Yup from 'yup';

const locationValidationSchema = Yup.object().shape({
    addrNo: Yup.string().required('Street number is required'),
    addrUnit: Yup.string(),
    addrStreet: Yup.string().required('Street name is required'),
    addrCity: Yup.string().required('City is required'),
    addrProvince: Yup.string().required('Province is required'),
    addrPostal: Yup.string().required('Postal code is required'),
    //addrCountry: Yup.string().required('Country is required'),
    website: Yup.string(),
    googleReviewLink: Yup.string(),
    name: Yup.string().required('Location name is required'),
    storePrefix: Yup.string()
    .required('Store prefix is required')
    .max(10, 'Store prefix must be 10 characters or less'),
    phone: Yup.string()
        .matches(
            /^\d{10}$/,
            'Phone number must be 10 digits and contain numbers only'
        )
        .required('Phone number is required'),
    fax: Yup.string()
        .matches(
            /^\d{10}$/,
            'Phone number must be 10 digits and contain numbers only'
        ),
    email: Yup.string()
        .email('Invalid email address'),
    timezone: Yup.string()
        .required('Timezone is required'),
    status: Yup.string(),
    logo: Yup.mixed(),
});

export default locationValidationSchema;